/* unplugin-vue-components disabled */import { render } from "./MedicationGuidance.vue?vue&type=template&id=6a2b34f8&scoped=true"
import script from "./MedicationGuidance.vue?vue&type=script&lang=js"
export * from "./MedicationGuidance.vue?vue&type=script&lang=js"

import "./MedicationGuidance.vue?vue&type=style&index=0&id=6a2b34f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2b34f8"]])

export default __exports__